module.exports = __webpack_public_path__ + "static/coworker1-ed06cb8ec5c340662c95248b9fc88e19.png";